const es = {
  nav: {
    features: "Funcionalidades",
    pricing: "Precios",
    blog: "Blog",
    about: "Quiénes somos",
    guides: "Guías",
    guide1: "Link in Bio para Creadores",
    guide2: "Link in Bio para Instagram",
    guide3: "Monetizar Instagram",
    guide4: "Vender Productos Digitales",
    guide5: "Link in Bio Gratis",
    guide6: "Reservas Online",
    dashboard: "Panel",
    logout: "Salir",
    login: "Iniciar sesión",
    register: "Registrarse gratis",
  },
  hero: {
    badge: "La plataforma de conversión para creadores",
    title1: "El link‑in‑bio que ",
    titleHighlight: "convierte seguidores en clientes",
    desc: "Un <strong>link in bio</strong> que vende de verdad: productos, <strong>reservas</strong> y analíticas en una sola página. El <strong>Deeplink™</strong> abre tus enlaces en el navegador real y no en el interno de las redes, así los pagos y las reservas se completan. Además, <strong>te pagamos por cada clic recibido</strong>.",
    cta: "Crea tu link que vende",
    ctaHint: "Prueba PRO de 7 días incluida",
    subCta: "Sin tarjeta · Configuración en 1 minuto · Cancela cuando quieras",
    imgAlt: "Mockup de la app TuttiIMieiLink",
    socialProof: "600+ creadores · 4.9/5",
    stickyCta: "Empieza gratis",
    stickyCtaVariantB: "Crea tu link que vende",
    stickyCtaVariantC: "Pruébalo gratis 7 días →",
    stickyCtaVariantD: "Empieza ahora — es gratis",
    statCreators: "creators activos",
    statClicks: "clics monetizados",
    statRating: "sobre 5 estrellas",
    demoBadge: "Demo en vivo",
    demoCaption: "Mira cómo un clic se convierte en venta",
    demoSaleLabel: "+€12 venta",
    demoLinkLabel: "Mi nuevo curso",
  },
  problem: {
    badge: "El problema",
    title1: "La mayoría de los link‑in‑bio son solo una ",
    titleMuted: "lista de enlaces",
    desc: "Recibes miles de clics de las redes sociales pero no los conviertes en clientes. El tráfico está ahí, las ventas no.",
    items: [
      "El tráfico llega pero nadie compra",
      "Tus analíticas muestran clics, no conversiones",
      "El navegador in-app bloquea checkouts e inscripciones",
    ],
  },
  solution: {
    badge: "La solución",
    title1: "Convierte tu link en un ",
    titleHighlight: "embudo de ventas",
    desc: "No es otro link‑in‑bio. Un sistema completo para convertir seguidores en clientes que pagan.",
    items: [
      { title: "Landing page personalizada", desc: "Un editor simple para crear páginas que convierten, no simples listas de enlaces." },
      { title: "Venta de productos digitales", desc: "Vende ebooks, cursos, plantillas y consultas directamente desde tu página." },
      { title: "Captura de emails y leads", desc: "Formularios integrados y lead magnets para hacer crecer tu lista y vender más." },
      { title: "Analíticas de conversión", desc: "No solo clics: mide CTR, conversiones y facturación generada por cada enlace." },
    ],
  },
  howItWorks: {
    title: "De seguidor a cliente en 3 pasos",
    subtitle: "Configuración rápida, resultados inmediatos",
    steps: [
      { title: "Crea tu página", desc: "Regístrate gratis y personaliza tu landing page con nuestro editor simple y rápido." },
      { title: "Añade enlaces o productos", desc: "Agrega tus enlaces de venta, productos digitales, formularios de contacto y lead magnets." },
      { title: "Convierte clics en clientes", desc: "Deeplink™ y las analíticas de conversión te muestran qué funciona. Optimiza y escala tu facturación." },
    ],
  },
  features: {
    badge: "Funciones principales",
    title: "Todo lo que necesitas para convertir",
    desc: "Cada función está diseñada para transformar el tráfico social en clientes que pagan.",
    uniqueBadge: "ÚNICOS",
    items: [
      { title: "Gana por cada clic", desc: "Somos la única plataforma que te paga por los clics recibidos. Hasta €0.01 por clic: cuanto más tráfico traigas, más ganas. Nadie más lo hace." },
      { title: "Smart Landing Page", desc: "Un editor de bloques para crear páginas de conversión: botones, videos, imágenes, cuentas regresivas y testimonios. Todo optimizado para vender." },
      { title: "Lead Capture", desc: "Formularios integrados para recopilar emails y contactos. Añade lead magnets para hacer crecer tu lista y vender más." },
      { title: "Deeplink™", desc: "Los enlaces sociales se abren en el navegador in-app y bloquean los checkouts. Nuestra tecnología fuerza la apertura en el navegador real: +40% de conversiones." },
      { title: "Shield Protection™", desc: "Filtra bots y clics sospechosos en tiempo real. Solo pagas por visitantes reales que compran." },
      { title: "Geo Filter", desc: "Muestra ofertas diferentes según el país del visitante. Precios localizados y redirecciones para tiendas regionales." },
      { title: "Analíticas de Conversión", desc: "No solo clics: mide CTR, conversiones y facturación. Descubre los enlaces más rentables y optimiza tu estrategia." },
    ],
  },
  comparison: {
    badge: "Comparación honesta",
    title: "¿Por qué no estás en Linktree?",
    desc: "Linktree es un gran comienzo. Pero si quieres <strong>vender</strong>, necesitas herramientas diferentes.",
    featureCol: "Funcionalidad",
    rows: [
      "Gana dinero por cada clic recibido",
      "Venta de productos digitales integrada",
      "Venta de productos físicos con envío",
      "Deeplink™ (abre en navegador real)",
      "Shield Protection™ anti-bot",
      "Geo Filter para ofertas localizadas",
      "Analíticas de conversión",
      "Landing page personalizable",
      "Dominio personalizado",
      "+40% conversiones en checkout",
      "Multi-link con tracking de ventas",
    ],
  },
  smartLinks: {
    badge: "Automatización Inteligente",
    title: "Enlaces que se adaptan a tu audiencia",
    desc: "Tus enlaces cambian automáticamente según el dispositivo, la hora del día y el país del visitante. Cero configuración, máximas conversiones.",
    autoLabel: "100% automático ✨",
    bottomHighlight: "Ningún competidor ofrece enlaces inteligentes automáticos. Solo TuttiIMieiLink.",
    rules: [
      {
        icon: "device",
        title: "Detección de Dispositivo",
        desc: "Muestra enlaces diferentes a usuarios de iPhone o Android. Envía automáticamente a la App Store correcta o a la versión móvil optimizada.",
        example: "📱 Descargar en App Store",
      },
      {
        icon: "time",
        title: "Hora del Día",
        desc: "Muestra ofertas diferentes según la hora: promociones flash por la noche, contenido formativo por la mañana. Tu funnel trabaja 24/7.",
        example: "🌙 Oferta nocturna -30%",
      },
      {
        icon: "geo",
        title: "País de Origen",
        desc: "Ofertas localizadas automáticamente: precios en moneda local, enlaces a tiendas regionales, contenido en el idioma del visitante.",
        example: "🇩🇪 Shop Deutschland",
      },
    ],
  },
  socialLogos: {
    title: "Integrado con las plataformas que amas",
  },
  creatorCarousel: {
    title: "Creadores que venden con TuttiIMieiLink",
    desc: "Únete a miles de creadores que monetizan su audiencia cada día",
  },
  stats: {
    badge: "Los resultados hablan",
    title: "No vanity metrics. Ventas reales.",
    items: [
      { value: "+40%", label: "Conversiones", desc: "Aumento promedio de conversiones gracias a Deeplink™ que abre los enlaces en el navegador real." },
      { value: "600+", label: "Creadores activos", desc: "Creadores que ya usan TuttiIMieiLink para monetizar su audiencia." },
      { value: "700+", label: "Clics rastreados", desc: "Clics reales rastreados y optimizados a través de la plataforma, en constante crecimiento." },
    ],
  },
  testimonial: {
    badge: "Testimonios",
    title: "Creadores que venden más",
    desc: "No confíes solo en nuestra palabra. Esto es lo que dicen los creadores que usan TuttiIMieiLink cada día.",
    items: [
      { quote: "Desde que uso TuttiIMieiLink las ventas de mis cursos desde Instagram han aumentado un 60%. Deeplink™ marca toda la diferencia.", name: "Luca M.", role: "Creador & Emprendedor Digital", metric: "+60% ventas" },
      { quote: "Probé Linktree, Beacons y otros. Con TuttiIMieiLink la tasa de conversión es el doble. Shield Protection me salvó de miles de clics de bots.", name: "Chiara R.", role: "Influencer de Moda · 120K seguidores", metric: "2x conversiones" },
      { quote: "Geo Filter es increíble: muestro ofertas diferentes a quienes están en Italia y quienes están en el extranjero. Los competidores no lo tienen. Configuración en 5 min.", name: "Marco B.", role: "Dueño de E-commerce", metric: "+40% CTR" },
      { quote: "Por fin una plataforma pensada para vender, no solo para poner enlaces. Las analíticas de conversión me dicen exactamente qué funciona.", name: "Sara T.", role: "Coach & Consultora", metric: "3x ROI" },
      { quote: "Mi audiencia es 80% móvil desde Instagram. Antes la mitad de los clics morían en el navegador in-app, ahora con Deeplink™ todos llegan al sitio real.", name: "Davide P.", role: "YouTuber & Podcaster", metric: "-50% rebote" },
      { quote: "Migré todo en una tarde. La interfaz es sencillísima y el soporte responde rápido. No vuelvo atrás.", name: "Elena F.", role: "Food Blogger", metric: "5 min setup" },
      { quote: "Uso TuttiIMieiLink para vender mis presets de Lightroom. Desde que activé el pay-per-click gano incluso con los visitantes que no compran. Genial.", name: "Giulia V.", role: "Fotógrafa & Content Creator", metric: "+€200/mes" },
      { quote: "Gestiono 5 creadores con el plan Agency. Tener todo en un solo panel con analíticas globales me ahorra horas cada semana.", name: "Andrea C.", role: "Social Media Manager", metric: "5 creadores, 1 panel" },
      { quote: "Mis alumnos hacen clic en el link in bio y llegan directamente al checkout sin bloqueos. Las inscripciones a mis cursos se han duplicado.", name: "Federica L.", role: "Instructora de Yoga Online", metric: "+100% inscripciones" },
      { quote: "Empecé con el plan Free para probar. Después de una semana pasé a Creator porque los resultados eran demasiado buenos para no invertir.", name: "Tommaso G.", role: "Músico Independiente", metric: "Free → Creator en 7d" },
    ],
  },
  pricing: {
    badge: "Invierte en tus ventas",
    title: "¿Cuánto vale un seguidor que compra?",
    desc: "Elige el plan que hace crecer tu facturación.",
    annual: "Anual -20%",
    monthly: "Mensual",
    earningsBanner: "La única plataforma que te paga por cada clic recibido",
    socialProof: "Ya <strong>1.000+</strong> creadores usan TuttiMieiLink",
    mostPopular: "Más popular",
    saveAnnual: "Ahorra un 20% con el plan anual.",
    loading: "Cargando...",
    plans: [
      {
        name: "Free",
        desc: "Prueba la plataforma con funcionalidades básicas. Cuando quieras crecer, pasa a Starter.",
        links: "Hasta 10 enlaces",
        cta: "Empieza gratis",
        features: ["1 página", "Hasta 10 enlaces", "Tecnología Deeplink™", "Shield Protection™", "Analíticas básicas (visitas y clics)", "Tip Jar — recibe donaciones", "Temas y fuentes personalizables", "Gana €0.005 por clic"],
      },
      {
        name: "Starter",
        desc: "Enlaces ilimitados, hasta 3 productos y analíticas de 7 días. Perfecto para empezar a vender.",
        links: "Enlaces ilimitados",
        cta: "Prueba gratis 7 días",
        features: [
          "Todo en Free, más:",
          "Enlaces ilimitados",
          "Hasta 3 productos digitales",
          "Analíticas últimos 7 días",
          "Códigos de descuento",
          "Tip Jar personalizado",
          "Temas premium",
          "Gana €0.005 por clic",
        ],
      },
      {
        name: "Creator",
        desc: "Analíticas avanzadas, captura de leads y venta de productos para maximizar cada conversión.",
        links: "Enlaces ilimitados",
        cta: "Prueba gratis 7 días",
        features: [
          "Todo en Starter, más:",
          "Productos ilimitados",
          "1 Dominio Personalizado",
          "Analíticas de conversión y CTR",
          "Captura de Leads y formularios email",
          "Productos físicos con envío",
          "Bundles de productos",
          "Membresías y suscriptores",
          "Testimonios",
          "Social Proof en tiempo real",
          "Smart Bio por fuente de tráfico",
          "Smart Links con programación",
          "Creator Score",
          "A/B Test posición de enlaces",
          "Píxeles Meta, TikTok y GA",
          "Automatizaciones de email",
          "Gana €0.01 por clic (2x)",
        ],
      },
      {
        name: "Agency",
        desc: "Gestiona múltiples creadores, embudos múltiples y panel avanzado desde un único lugar.",
        links: "Enlaces ilimitados",
        cta: "Prueba gratis 7 días",
        features: [
          "Todo en Creator, más:",
          "2 Dominios Personalizados",
          "Gestión multi-creador",
          "Colaboraciones entre creadores",
          "Embudos múltiples con IA",
          "Panel de analíticas global",
          "CRM de contactos y leads",
          "Importación de productos CSV",
          "Programa de referidos",
          "Gana €0.01 por clic (2x)",
        ],
      },
    ],
    miniTestimonials: [
      { quote: "Desde que uso TuttiMieiLink mis ventas aumentaron un 35%. ¡El checkout express es increíble!", name: "Giulia R.", role: "Content Creator" },
      { quote: "Por fin una plataforma que me paga por los clics. Ya gané €120 en un mes.", name: "Marco T.", role: "Influencer" },
      { quote: "Usé Linktree durante 2 años. Con TuttiMieiLink mis seguidores realmente compran.", name: "Sara M.", role: "Fashion Blogger" },
    ],
  },
  faq: {
    badge: "FAQ",
    title: "Preguntas frecuentes",
    items: [
      { q: "¿Cómo me ayuda TuttiIMieiLink a vender más?", a: "La tecnología Deeplink™ fuerza la apertura de tus enlaces en el navegador real, evitando el navegador in-app que bloquea checkouts y pagos. Resultado: +40% de conversiones promedio en compras e inscripciones." },
      { q: "¿Qué diferencia hay respecto a Linktree u otros link-in-bio?", a: "Los demás te dan una lista de enlaces. Nosotros te damos un sistema de ventas: Deeplink™ para conversiones, Shield Protection™ contra el tráfico falso, Geo Filter para ofertas localizadas y analíticas enfocadas en conversiones, no en vanity metrics." },
      { q: "¿Puedo usarlo para vender cursos, merch, consultas?", a: "Absolutamente. Cualquier enlace de venta — Gumroad, Shopify, Teachable, Calendly, Ko-fi — funciona mejor con Deeplink™. Tus seguidores llegan al checkout sin bloqueos." },
      { q: "¿Cómo funciona Shield Protection™?", a: "Shield analiza el tráfico en tiempo real y filtra bots, clics sospechosos y visitas falsas. Así tus analíticas muestran solo visitantes reales y tu presupuesto de publicidad no se desperdicia." },
      { q: "¿Puedo conectar un dominio personalizado?", a: "¡Sí! Con el plan Creator o superior puedes conectar tu dominio para un aspecto más profesional y aumentar la confianza de tus potenciales clientes." },
    ],
  },
  ctaFooter: {
    title: "Deja de perder ventas desde tu bio link",
    desc: "Cada día que pasas con un link-in-bio genérico, pierdes clientes. Deeplink™, Shield y analíticas de conversión: todo gratis para empezar.",
    cta: "Empieza gratis",
    brandDesc: "El link-in-bio que ayuda a los creadores a vender.",
    copyright: "© {{year}} TuttiIMieiLink. Todos los derechos reservados.",
    footerSections: {
      product: "Producto",
      resources: "Recursos",
      company: "Empresa",
      legal: "Legal",
    },
    footerLinks: {
      features: "Funcionalidades",
      pricing: "Precios",
      guide1: "Link in Bio para Creadores",
      guide2: "Link in Bio para Instagram",
      guide3: "Monetizar Instagram",
      guide4: "Vender Productos Digitales",
      about: "Quiénes somos",
      contact: "Contacto",
      terms: "Términos de uso",
      privacy: "Política de Privacidad",
      cookie: "Política de Cookies",
    },
  },
  scrollingTags: ["Vender Cursos Online", "Merch & E-commerce", "Consultoría", "Afiliaciones", "Productos Digitales", "Coaching"],
  auth: {
    back: "Volver al inicio",
    loginTitle: "Inicia sesión en tu cuenta",
    loginSubtitle: "¡Bienvenido de nuevo! Entra para gestionar tu página",
    registerTitle: "Crea una nueva cuenta",
    continueGoogle: "Continuar con Google",
    continueApple: "Continuar con Apple",
    or: "o",
    email: "Email",
    password: "Contraseña",
    forgotPassword: "¿Olvidaste tu contraseña?",
    login: "Iniciar sesión",
    register: "Registrarse",
    loading: "Cargando...",
    noAccount: "¿No tienes una cuenta?",
    hasAccount: "¿Ya tienes una cuenta?",
    forgotDesc: "Introduce tu email para recibir el enlace de restablecimiento",
    sendReset: "Enviar enlace de restablecimiento",
    sending: "Enviando...",
    backToLogin: "Volver al login",
    checkEmail: "Revisa tu email",
    resetSent: "Te hemos enviado un enlace para restablecer tu contraseña.",
    welcome: "¡Bienvenido!",
    loginSuccess: "Sesión iniciada correctamente.",
    accountCreated: "¡Cuenta creada!",
    accountCreatedDesc: "Tu cuenta ha sido creada exitosamente.",
    accountCreatedConfirmEmailDesc: "Te hemos enviado un email de confirmación. Ábrelo para activar tu cuenta antes de iniciar sesión.",
    accountAlreadyExistsDesc: "Ya existe una cuenta con este email. Revisa tu bandeja o prueba a iniciar sesión.",
    invalidCredentials: "Email o contraseña incorrectos. Inténtalo de nuevo o restablece la contraseña.",
    referralInvite: "Te ha invitado un creador: regístrate para activar la invitación.",
    resetEmailSent: "¡Email enviado!",
    resetEmailDesc: "Revisa tu bandeja para el enlace de restablecimiento.",
    error: "Error",
    passwordHint: "Mínimo 6 caracteres. Evita contraseñas comunes como \"123456\" o \"password\".",
    passwordWeakError: "La contraseña es demasiado común o comprometida. Elige una más segura.",
    quickStart: "Empieza en 10 segundos",
    quickStartDesc: "Sin tarjeta · 7 días gratis · Cancela cuando quieras",
    useEmail: "Continuar con email",
    benefit1: "Enlaces en bio ilimitados",
    benefit2: "Analíticas detalladas en tiempo real",
    benefit3: "Vende productos y servicios sin comisiones",
  },
  resetPassword: {
    backToLogin: "Volver al login",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    update: "Actualizar contraseña",
    updating: "Actualizando...",
    updated: "Contraseña actualizada",
    updatedDesc: "Ahora puedes iniciar sesión con tu nueva contraseña.",
    goToLogin: "Ir al login",
    invalidLink: "Enlace no válido",
    invalidLinkDesc: "Este enlace de restablecimiento no es válido o ha expirado. Solicita un nuevo enlace desde la página de login.",
    enterNew: "Introduce tu nueva contraseña",
    mismatch: "Las contraseñas no coinciden.",
    tooShort: "La contraseña debe tener al menos 6 caracteres.",
    success: "¡Contraseña actualizada!",
    successDesc: "Tu contraseña ha sido cambiada exitosamente.",
    error: "Error",
  },
  notFound: {
    title: "404",
    message: "¡Ups! Página no encontrada",
    backHome: "Volver al Inicio",
  },
  contatti: {
    back: "Volver al inicio",
    title: "Contáctanos",
    desc: "Envía sugerencias, reporta errores o haz preguntas",
    categories: {
      suggestion: "💡 Sugerencia",
      bug: "🐛 Error",
      question: "❓ Pregunta",
      other: "📝 Otro",
    },
    yourEmail: "Tu email",
    category: "Categoría",
    subject: "Asunto",
    subjectPlaceholder: "¿De qué se trata?",
    message: "Mensaje",
    messagePlaceholder: "Describe en detalle...",
    send: "Enviar mensaje",
    sending: "Enviando...",
    sent: "¡Mensaje enviado!",
    sentDesc: "Gracias por escribirnos, te responderemos lo antes posible.",
    sendAnother: "Enviar otro mensaje",
    enterEmail: "Introduce tu email",
    error: "Error",
    errorDesc: "No se pudo enviar el mensaje.",
  },
  chiSiamo: {
    badge: "Nuestra misión",
    title1: "Ayudamos a los creadores a ",
    titleHighlight: "vender más",
    desc: "TuttiIMieiLink nació con un objetivo claro: transformar tu link-in-bio de una simple lista de enlaces en una poderosa herramienta de ventas, con analíticas, deeplink y protección contra denuncias.",
    stats: [
      { value: "10K+", label: "Creadores activos" },
      { value: "50K+", label: "Páginas creadas" },
      { value: "2M+", label: "Clics rastreados" },
      { value: "99.9%", label: "Uptime garantizado" },
    ],
    timelineTitle: "Nuestro recorrido",
    milestones: [
      { year: "2024", title: "Nace la idea", desc: "Cansados de link-in-bio genéricos que no convierten, empezamos a construir algo diferente." },
      { year: "2024", title: "Lanzamiento beta", desc: "Primeras 500 páginas creadas. El feedback de los creadores nos guió hacia Deeplink™ y analíticas avanzadas." },
      { year: "2025", title: "Crecimiento explosivo", desc: "10.000+ creadores confían en TuttiIMieiLink para vender productos digitales y hacer crecer su marca." },
      { year: "2025", title: "El futuro", desc: "A/B testing, pixel tracking, captura de leads y mucho más. Solo estamos empezando." },
    ],
    earningBadge: "ÚNICOS",
    earningTitle1: "Te pagamos por cada ",
    earningTitleHighlight: "clic recibido",
    earningDesc: "Somos la única plataforma link-in-bio que comparte ingresos con los creadores. Cuanto más tráfico traigas, más ganas. Es simple.",
    earningCards: [
      { title: "€0.005 / clic", subtitle: "Plan Free", desc: "Incluso con el plan gratuito empiezas a ganar por cada clic recibido en tus enlaces." },
      { title: "€0.01 / clic", subtitle: "Plan Premium", desc: "Con Creator o Agency duplicas la ganancia por clic. El doble de valor, el mismo tráfico.", recommended: "RECOMENDADO" },
      { title: "€10 umbral", subtitle: "Pago PayPal", desc: "Alcanza €10 de saldo y solicita el pago directamente a tu cuenta PayPal." },
    ],
    howItWorksTitle: "¿Cómo funciona?",
    howItWorksSteps: [
      "Crea tu página y añade tus enlaces",
      "Comparte tu link-in-bio en redes sociales",
      "Cada clic se rastrea y se acredita",
      "Alcanza €10 y solicita tu pago PayPal",
    ],
    valuesTitle: "Nuestros valores",
    valuesDesc: "Todo lo que hacemos está guiado por estos principios.",
    values: [
      { title: "Conversiones primero", desc: "Cada función está pensada para ayudarte a vender más, no solo para verse bien." },
      { title: "Protección del creador", desc: "Deeplink™ y Shield protegen tu cuenta de las denuncias." },
      { title: "Community driven", desc: "El feedback de los creadores guía cada decisión de producto." },
    ],
  },
  terms: {
    title: "Términos de uso",
    lastUpdate: "Última actualización: Marzo 2026",
    sections: [
      { title: "1. Aceptación de los términos", content: "Al acceder y utilizar TuttiIMieiLink (\"la Plataforma\"), aceptas quedar vinculado por los presentes Términos de uso. Si no aceptas estos términos, te invitamos a no utilizar el servicio." },
      { title: "2. Descripción del servicio", content: "TuttiIMieiLink es una plataforma que permite a los creadores crear páginas link-in-bio personalizadas, vender productos digitales, capturar leads y monitorear el rendimiento mediante analíticas avanzadas." },
      { title: "3. Registro y cuenta", content: "Para utilizar algunas funcionalidades de la Plataforma es necesario crear una cuenta. El usuario es responsable de la confidencialidad de sus credenciales y de todas las actividades realizadas a través de su cuenta." },
      { title: "4. Planes y pagos", content: "La Plataforma ofrece planes gratuitos y de pago. Los planes de pago se facturan mensual o anualmente a través de Stripe. El usuario puede gestionar o cancelar su suscripción en cualquier momento desde el panel." },
      { title: "5. Contenido del usuario", content: "El usuario mantiene la propiedad de todo el contenido subido a la Plataforma. Concede a TuttiIMieiLink una licencia limitada para alojar y mostrar dicho contenido con el fin de prestar el servicio." },
      { title: "6. Uso aceptable", content: "El usuario se compromete a no utilizar la Plataforma para fines ilegales, para difundir contenido ofensivo, spam o malware. TuttiIMieiLink se reserva el derecho de suspender las cuentas que violen estos términos." },
      { title: "7. Programa de ganancias por clic", content: "Los usuarios pueden ganar una comisión por cada clic recibido en sus páginas. Las tarifas y condiciones de pago están sujetas a cambios con previo aviso. El retiro está disponible al alcanzar el umbral mínimo de €10." },
      { title: "8. Limitación de responsabilidad", content: "La Plataforma se proporciona \"tal cual\". TuttiIMieiLink no garantiza un funcionamiento ininterrumpido y no es responsable de los daños derivados del uso del servicio." },
      { title: "9. Cambios en los términos", content: "TuttiIMieiLink se reserva el derecho de modificar los presentes términos en cualquier momento. Los cambios se comunicarán por email o notificación en la Plataforma." },
      { title: "10. Contacto", content: "Para preguntas sobre estos términos, contáctanos en la página de <a>Contacto</a>." },
    ],
  },
  privacy: {
    title: "Política de Privacidad",
    lastUpdate: "Última actualización: Marzo 2026",
    sections: [
      { title: "1. Responsable del tratamiento", content: "El responsable del tratamiento de datos es TuttiIMieiLink. Para contactarnos, visita la página de <a>Contacto</a>." },
      { title: "2. Datos recopilados", content: "Recopilamos los siguientes datos:", list: ["Datos de registro: email, nombre visible", "Datos de uso: vistas de página, clics en enlaces, referrer", "Datos de pago: gestionados íntegramente por Stripe; no almacenamos datos de tarjetas de crédito", "Datos técnicos: dirección IP, navegador, dispositivo (para analíticas)"] },
      { title: "3. Finalidad del tratamiento", content: "Los datos se utilizan para:", list: ["Prestar el servicio y gestionar la cuenta del usuario", "Proporcionar analíticas y estadísticas sobre el rendimiento de las páginas", "Gestionar pagos y suscripciones", "Calcular las ganancias por clic", "Mejorar el servicio y la experiencia del usuario"] },
      { title: "4. Base jurídica", content: "El tratamiento de datos se basa en el consentimiento del usuario en el momento del registro y en la ejecución del contrato de servicio." },
      { title: "5. Compartición de datos", content: "No vendemos los datos de los usuarios a terceros. Compartimos datos solo con:", list: ["Stripe: para la gestión de pagos", "Proveedor de hosting: para la prestación del servicio"] },
      { title: "6. Conservación de datos", content: "Los datos se conservan durante la vigencia de la cuenta activa y por el período requerido por la normativa aplicable después de la cancelación." },
      { title: "7. Derechos del usuario", content: "De conformidad con el GDPR, el usuario tiene derecho a:", list: ["Acceder a sus datos personales", "Solicitar la rectificación o eliminación de datos", "Oponerse al tratamiento", "Solicitar la portabilidad de datos"] },
      { title: "8. Seguridad", content: "Adoptamos medidas de seguridad técnicas y organizativas para proteger los datos personales, incluida la encriptación de las comunicaciones y el acceso restringido a los datos." },
    ],
  },
  cookie: {
    title: "Política de Cookies",
    lastUpdate: "Última actualización: Marzo 2026",
    sections: [
      { title: "1. Qué son las cookies", content: "Las cookies son pequeños archivos de texto almacenados en el dispositivo del usuario cuando visita un sitio web. Se utilizan para mejorar la experiencia de navegación y proporcionar funcionalidades esenciales." },
      { title: "2. Cookies utilizadas", content: "" },
      { title: "Cookies técnicas (necesarias)", content: "Estas cookies son esenciales para el funcionamiento de la Plataforma:", list: ["Sesión de autenticación: para mantener el acceso a la cuenta", "Preferencias de usuario: para almacenar la configuración"], isH3: true },
      { title: "Cookies analíticas", content: "Utilizamos cookies analíticas para comprender cómo los usuarios interactúan con la Plataforma:", list: ["Google Analytics: si configurado por el usuario en sus páginas", "Analíticas internas: para rastrear vistas y clics"], isH3: true },
      { title: "Cookies de terceros", content: "Algunas cookies pueden ser establecidas por servicios de terceros:", list: ["Stripe: para la gestión segura de pagos", "Meta Pixel / TikTok Pixel: si configurados por el usuario en sus páginas"], isH3: true },
      { title: "3. Gestión de cookies", content: "El usuario puede gestionar las preferencias de cookies a través de la configuración de su navegador. La desactivación de algunas cookies podría afectar al funcionamiento de la Plataforma." },
      { title: "4. Duración de las cookies", content: "", list: ["Cookies de sesión: se eliminan al cerrar el navegador", "Cookies persistentes: permanecen en el dispositivo por un período definido o hasta la eliminación manual"] },
      { title: "5. Actualizaciones", content: "Esta Política de Cookies puede actualizarse periódicamente. Cualquier cambio se publicará en esta página." },
      { title: "6. Contacto", content: "Para preguntas sobre la Política de Cookies, visita la página de <a>Contacto</a>." },
    ],
  },
  copilot: {
    title: "Growth Copilot",
    intro: "Tu estratega con IA: analiza los datos reales de tu página (visitas, clics, ventas, leads) y te dice qué hacer ahora.",
    empty: "Pregúntame lo que quieras sobre el crecimiento de tu página.",
    thinking: "Analizando tus datos…",
    placeholder: "Ej. ¿Cómo consigo más clics en mis enlaces?",
    errTitle: "Copilot no disponible",
    errRate: "Demasiadas solicitudes, inténtalo en un momento.",
    errCredits: "Créditos de IA agotados.",
    errNoPage: "Crea primero tu página.",
    errGeneric: "Error, inténtalo de nuevo.",
    suggestions: [
      "¿Qué debo mejorar esta semana?",
      "¿Cómo consigo más clics en mis enlaces?",
      "¿Cómo gano más con mi página?",
      "Analiza mi embudo y dime dónde pierdo visitantes",
    ],
  },
  dashboard: {
    home: "Inicio",
    yourPage: "Tu página",
    yourPageDesc: "Crea y personaliza tu página link-in-bio",
    editPage: "Editar Página",
    editLinks: "Tus Enlaces",
    analyticsTitle: "Analíticas",
    feedback: "Comentarios",
    referral: "Referidos",
    earnings: "Ganancias",
    collaborations: "Colaboraciones",
    testimonials: "Testimonios",
    socialProof: "Prueba Social",
    abTest: "Test A/B",
    loading: "Cargando...",
    subscription: "Suscripción",
    refresh: "Actualizar",
    checking: "Verificando...",
    activePlan: "Plan activo",
    nextRenewal: "Próxima renovación:",
    manageSubscription: "Gestionar suscripción",
    freePlan: "Plan Free",
    noSubscription: "Sin suscripción activa",
    choosePlan: "Elige un plan",
    premiumFeature: "Función Premium",
    upgradeToAccess: "Pasa a un plan PRO para acceder a esta función.",
    unlockTitle: "Desbloquea todo el potencial",
    unlockDesc: "Pasa a un plan premium para acceder a <strong>analíticas avanzadas</strong>, <strong>productos digitales</strong>, <strong>captura de leads</strong>, <strong>pixel tracking</strong>, <strong>A/B testing</strong> y enlaces ilimitados.",
    discoverPlans: "Descubre los planes premium",
    lockedAnalytics: "Analíticas",
    lockedProducts: "Productos",
    lockedAI: "IA",
    lockedBooking: "Reservas",
    lockedMembership: "Membresía",
    lockedSmartBio: "Smart Bio",
    portalError: "No se pudo abrir el portal.",
    trialTitle: "Periodo de prueba gratuito",
    trialRemaining: "{{days}} días restantes en tu prueba",
    trialUrgent: "¡Solo {{days}} días y {{hours}} horas restantes!",
    trialProgress: "Día {{used}} de {{total}}",
    trialCta: "Activa tu plan ahora para no perder el acceso a las funciones premium.",
    trialUpgrade: "Activar plan",
    error: "Error",
    saved: "¡Guardado!",
    save: "Guardar",
    saving: "Guardando...",
    cancel: "Cancelar",
    delete: "Eliminar",
    add: "Añadir",
    pageSettings: "Configuración de página",
    pagePhoto: "Foto de la página",
    uploading: "Subiendo...",
    usernameLabel: "Username (URL de la página)",
    usernamePlaceholder: "tuusername",
    usernameRequired: "El username es obligatorio.",
    usernameInvalid: "El username solo puede contener letras, números, - y _",
    titleLabel: "Título",
    titlePlaceholder: "Tu nombre o marca",
    bioLabel: "Bio",
    bioPlaceholder: "Describe quién eres...",
    themeLabel: "Tema de la página",
    customizeColors: "Personalizar colores",
    resetDefault: "Restablecer predeterminado",
    colorBg: "Fondo",
    colorCard: "Tarjeta",
    colorText: "Texto",
    colorAccent: "Acento",
    fontLabel: "Fuente de la página",
    previewLabel: "Vista previa del tema",
    saveSettings: "Guardar configuración",
    settingsSaved: "La configuración de la página ha sido actualizada.",
    duplicateUsername: "Este username ya está en uso. Elige otro.",
    cantSave: "No se pudo guardar la configuración.",
    deletePage: "Eliminar página",
    deletePageConfirm: "¿Eliminar la página?",
    deletePageDesc: "Esta acción es irreversible. La página, todos los enlaces y las estadísticas asociadas serán eliminados permanentemente.",
    deleting: "Eliminando...",
    deleteForever: "Eliminar definitivamente",
    pageDeleted: "Página eliminada",
    pageDeletedDesc: "Tu página ha sido eliminada.",
    cantDelete: "No se pudo eliminar la página.",
    photoUpdated: "¡Foto actualizada!",
    photoTooBig: "La imagen debe ser inferior a 2MB.",
    cantUploadPhoto: "No se pudo subir la foto.",
    yourName: "Tu nombre",
    yourBio: "Tu bio...",
    previewInstagram: "Instagram",
    previewYouTube: "YouTube",
    previewWebsite: "Mi web",
    yourLinks: "Tus enlaces",
    savePageFirst: "Guarda primero la configuración de la página para añadir enlaces.",
    linkTitlePlaceholder: "Título del enlace",
    linkUrlPlaceholder: "https://ejemplo.com",
    linkAdded: "¡Enlace añadido!",
    cantAddLink: "No se pudo añadir el enlace.",
    invalidUrl: "La URL ingresada no es válida.",
    urlNotReachable: "El sitio web no existe o no es accesible. Verifica la URL e inténtalo de nuevo.",
    cantLoadLinks: "No se pudieron cargar los enlaces.",
    linkDeleted: "Enlace eliminado.",
    linkUpdated: "¡Enlace actualizado!",
    cantUpdateLink: "No se pudo actualizar el enlace.",
    noLinksYet: "Ningún enlace aún. ¡Añade uno arriba!",
    linkLimitReached: "Límite alcanzado",
    linkLimitDesc: "El plan gratuito permite máximo {{limit}} enlaces. Pasa a un plan de pago para enlaces ilimitados.",
    linkLimitUpgrade: "Has alcanzado el límite de {{limit}} enlaces del plan gratuito.",
    upgradeToCreator: "Pasa a Creator",
    unlimitedLinks: "para enlaces ilimitados.",
    analytics: "Analíticas",
    totalViews: "Visitas totales",
    totalClicks: "Clics totales",
    ctr: "CTR",
    sales: "Ventas",
    revenue: "Facturación",
    leadsCollected: "Leads capturados",
    last30days: "Últimos 30 días",
    salesAndRevenue: "Ventas y facturación (30 días)",
    clicksPerLink: "Clics por enlace",
    topReferrer: "Top referrers",
    noReferrerYet: "Ningún referrer registrado aún.",
    visits: "visitas",
    visitsChart: "Visitas",
    clicksChart: "Clics",
    salesChart: "Ventas",
    revenueChart: "Facturación",
    products: "Productos",
    digitalProducts: "Productos Digitales",
    digitalProductsLockedDesc: "La venta de productos está disponible con el plan Creator o superior.",
    digitalProductsSellDesc: "Vende ebooks, plantillas, cursos y productos físicos directamente desde tu página.",
    unlockWithCreator: "Desbloquear con Creator",
    discoverPlansLink: "Descubre los planes",
    productNamePlaceholder: "Nombre del producto *",
    productDescPlaceholder: "Descripción (opcional)",
    productPricePlaceholder: "Precio (€) *",
    productFilePlaceholder: "Archivo del producto (PDF, ZIP...)",
    productCoverPlaceholder: "Imagen de portada",
    invalidPrice: "Precio no válido",
    productCreated: "¡Producto creado!",
    createProduct: "Crear producto",
    productUpdated: "¡Producto actualizado!",
    replaceFile: "Reemplazar archivo",
    addFile: "Añadir archivo",
    replaceCover: "Reemplazar portada",
    addCover: "Añadir portada",
    noFile: "Sin archivo",
    deleteProductConfirm: "¿Eliminar este producto?",
    deleteAllProducts: "Eliminar todos",
    deleteAllProductsConfirm: "¿Estás seguro de que quieres eliminar TODOS los productos? Esta acción es irreversible.",
    allProductsDeleted: "Todos los productos han sido eliminados",
    noProductsYet: "Ningún producto aún. ¡Añade tu primer producto!",
    typeDigital: "Digital",
    typePhysical: "Físico",
    physicalProductNote: "Para productos físicos, se recogerá la dirección de envío en el checkout. Recibirás los detalles del pedido y la dirección por email.",
    shippingCostPlaceholder: "Costo de envío (€)",
    shippingCostHint: "0 = envío gratuito",
    shipping: "Envío",
    csvImportTitle: "Importar desde CSV / Excel",
    csvImportDesc: "Sube un archivo CSV o Excel con columnas: title, description, price, currency. Los productos se crearán como físicos.",
    csvSelectFile: "Seleccionar archivo CSV o Excel",
    csvDownloadTemplate: "Descargar plantilla",
    csvNoRows: "El archivo no contiene filas de datos.",
    csvRow: "Fila",
    csvMissingTitle: "título faltante",
    csvInvalidPrice: "precio inválido:",
    csvMaxRows: "Máximo 100 productos por importación.",
    csvParseError: "Error al leer el archivo. Verifica el formato.",
    csvImportSuccess: "¡{{count}} productos importados con éxito!",
    csvImporting: "Importando...",
    csvConfirmImport: "Importar {{count}} productos",
    csvHeaderTitle: "Título",
    csvHeaderDesc: "Descripción",
    csvHeaderPrice: "Precio",
    ordersTitle: "Pedidos de productos físicos",
    ordersDesc: "{{count}} pedidos recibidos",
    orderBuyer: "Comprador",
    orderAddress: "Dirección de envío",
    orderShippingStatus: "Estado del envío",
    orderNotes: "Notas",
    orderNotesPlaceholder: "Número de tracking, notas internas...",
    orderUpdated: "Pedido actualizado",
    orderDate: "Fecha",
    orderProduct: "Producto",
    orderBuyerName: "Nombre destinatario",
    orderPrice: "Precio",
    csvExported: "CSV exportado correctamente",
    noAddress: "Dirección no disponible",
    orderStatus_pending: "Pendiente",
    orderStatus_processing: "En proceso",
    orderStatus_shipped: "Enviado",
    orderStatus_delivered: "Entregado",
    earningsRateInfo: "Ganas <strong>{{rate}}</strong> por cada clic en tus enlaces.",
    earningsUpgrade: "¡Pasa a premium para duplicarlo!",
    earningsPPCOnly: "Este es solo el programa Pay-Per-Click. Las donaciones y membresías van directamente a tu Stripe — ",
    stripeDashboardLink: "gestiona tu cuenta bancaria en dashboard.stripe.com",
    openStripeDashboard: "Abrir Stripe Dashboard",
    balance: "Saldo",
    totalEarned: "Total ganado",
    withdrawn: "Retirado",
    paypalEmail: "Email PayPal",
    paypalPlaceholder: "tu-email@paypal.com",
    paypalSaved: "Email PayPal actualizado.",
    requestPayout: "Solicitar pago",
    payoutMin: "mín. {{amount}}",
    payoutSending: "Enviando...",
    payoutSent: "¡Solicitud enviada!",
    payoutSentDesc: "Pago de €{{amount}} en proceso.",
    payoutMissingEmail: "Introduce primero tu email PayPal.",
    payoutMissing: "Faltan {{amount}} para alcanzar el umbral mínimo.",
    payoutHistory: "Historial de solicitudes",
    payoutCompleted: "Completado",
    payoutRejected: "Rechazado",
    payoutPending: "Pendiente",
    attention: "Atención",
    onboardingWelcome: "¡Bienvenido! Configuremos tu página",
    onboardingSubtitle: "Solo 3 pasos para estar en línea",
    publishBannerTitle: "Tu página aún no está en línea — publícala ahora",
    publishBannerDesc: "Solo te falta un paso: elige tu nombre de usuario, añade tu primer enlace y tu página estará lista para compartir en tu bio. Solo 2 minutos.",
    onboardingStep1: "Perfil",
    onboardingStep1Desc: "Elige tu username",
    onboardingStep2: "Personaliza",
    onboardingStep2Desc: "Título y bio",
    onboardingStep3: "Primer enlace",
    onboardingStep3Desc: "Añade un enlace",
    profilePhoto: "Foto de perfil",
    profilePhotoHint: "Opcional, máx 2MB",
    chooseUsername: "Elige tu username",
    usernameMin3: "Mínimo 3 caracteres",
    pageTitle: "Título de la página",
    pageBio: "Bio",
    pageBioPlaceholder: "Describe quién eres en pocas palabras...",
    editLaterHint: "Puedes editar todo después desde el panel.",
    firstLinkHint: "Añade tu primer enlace. Podrás añadir más después.",
    linkTitleExample: "ej. Instagram",
    linkUrlExample: "https://instagram.com/tuperfil",
    optionalStep: "Este paso es opcional — puedes saltarlo.",
    back: "Atrás",
    next: "Siguiente",
    creating: "Creando...",
    createMyPage: "Crear mi página",
    pageReady: "¡Tu página está lista! 🎉",
    pageReadyDesc: "¡Fantástico! Tu página link-in-bio ha sido creada con éxito.",
    goToDashboard: "Ir al panel",
    pageCreatedToast: "¡Página creada! 🎉",
    pageCreatedToastDesc: "Ahora personaliza tu panel.",
    usernameInUse: "Username ya en uso. Elige otro.",
    pageCreateError: "Error al crear la página.",
    uploadFailed: "Subida fallida.",
    // Onboarding Checklist
    checklistTitle: "Configura tu página",
    checklistAllDone: "¡Todo completado! 🎉",
    checklistDismiss: "Ocultar checklist",
    checklistAvatar: "Añade una foto de perfil",
    checklistAvatarDesc: "Los perfiles con foto reciben un 40% más de clics.",
    checklistBio: "Escribe una bio",
    checklistBioDesc: "Cuéntale a los visitantes quién eres y qué haces.",
    checklistLinks: "Añade al menos 3 enlaces",
    checklistLinksDesc: "Más enlaces = más oportunidades de conversión.",
    checklistShare: "Comparte tu página",
    checklistShareDesc: "Envía el enlace a tus seguidores en redes sociales.",
    checklistShareAction: "Compartir",
    checklistPremium: "Activa un plan Premium",
    checklistPremiumDesc: "Desbloquea analytics, captación de leads y ganancias por clic.",
    checklistPremiumAction: "Ver planes",
    openPage: "Abrir página",
    copyUrl: "Copiar URL",
    qrCode: "Código QR",
    downloadPng: "Descargar PNG",
    contactTeam: "Contacta al equipo",
    contactTeamDesc: "Envía sugerencias, reporta errores o haz preguntas",
    feedbackSent: "¡Mensaje enviado!",
    feedbackSentDesc: "Gracias por tu feedback, lo leeremos pronto.",
    categoryLabel: "Categoría",
    categorySuggestion: "💡 Sugerencia",
    categoryBug: "🐛 Error",
    categoryQuestion: "❓ Pregunta",
    categoryOther: "📝 Otro",
    subjectLabel: "Asunto",
    subjectPlaceholder: "¿De qué se trata?",
    messageLabel: "Mensaje",
    messagePlaceholder: "Describe en detalle...",
    sendMessage: "Enviar mensaje",
    sending: "Enviando...",
    feedbackReplies: "{{count}} respuesta(s) del equipo",
    feedbackAdminReply: "Respuesta del equipo",
    leadCapture: "Captura de Leads",
    leadCaptureLockedTitle: "Función disponible con el plan Creator o Agency",
    leadCaptureLockedDesc: "Captura emails y contactos directamente desde tu página.",
    upgrade: "Upgrade",
    enableFormOnPage: "Activar formulario en la página",
    enableFormDesc: "Los visitantes podrán suscribirse a tu lista",
    formTitle: "Título del formulario",
    formDescription: "Descripción",
    leadMagnetUrl: "URL Lead Magnet (opcional)",
    leadMagnetPlaceholder: "https://ejemplo.com/ebook.pdf",
    leadMagnetHint: "Después de suscribirse, el usuario será redirigido a este enlace.",
    leadsCollectedCount: "Leads capturados ({{count}})",
    exportCsv: "Exportar CSV",
    noLeadsYet: "Ningún lead aún. ¡Activa el formulario y comparte tu página!",
    leadDeleted: "Lead eliminado.",
    leadCaptureSaved: "La configuración de captura de leads ha sido actualizada.",
    cantSaveLead: "No se pudo guardar.",
    pixelTracking: "Pixel Tracking",
    pixelTrackingLockedDesc: "Rastrea conversiones con Meta Pixel, TikTok Pixel y Google Analytics directamente desde tu página.",
    metaPixelId: "Meta Pixel ID",
    metaPixelPlaceholder: "Ej. 123456789012345",
    metaPixelHint: "Encuentra el ID en tu Meta Events Manager",
    tiktokPixelId: "TikTok Pixel ID",
    tiktokPixelPlaceholder: "Ej. ABCDEF123456",
    tiktokPixelHint: "Encuentra el ID en TikTok Ads Manager → Events",
    googleAnalyticsId: "Google Analytics ID",
    googleAnalyticsPlaceholder: "Ej. G-XXXXXXXXXX",
    googleAnalyticsHint: "Encuentra el ID en Google Analytics → Administración → Flujos de datos",
    pixelSaved: "¡Píxeles guardados!",
    savePixels: "Guardar píxeles",
    abTestPosition: "A/B Test Posición",
    abTestLockedDesc: "Prueba automáticamente el orden de los enlaces en tu página para descubrir qué posición genera más clics.",
    abTestEnabled: "El orden de los enlaces se aleatoriza para cada visitante. Los datos se actualizan a medida que recopilas clics.",
    abTestDisabled: "Activa para mostrar los enlaces en orden aleatorio a los visitantes y descubrir qué posición funciona mejor.",
    abTestActivated: "¡A/B Test activado!",
    abTestDeactivated: "A/B Test desactivado",
    trackedClicksWithPos: "Clics rastreados con posición",
    noDataYetEnabled: "Sin datos aún. Los resultados aparecerán cuando los visitantes empiecen a hacer clic.",
    noDataYetDisabled: "Activa el A/B test para empezar a recopilar datos.",
    resultsPerLink: "Resultados por enlace",
    deletedLink: "Enlace eliminado",
    positionLabel: "Pos.",
    positionWinner: "🏆 Posición {{pos}} es la ganadora",
    clicks: "clics",
    defaultFormTitle: "Suscríbete al newsletter",
    defaultFormDesc: "Recibe actualizaciones exclusivas directamente en tu bandeja.",
    bundleTitle: "Bundle",
    createBundle: "Crear bundle",
    bundleNamePlaceholder: "Nombre del bundle (ej. Pack Completo)",
    bundleDescPlaceholder: "Descripción (opcional)",
    percentDiscount: "% de descuento",
    fixedDiscount: "céntimos de descuento",
    selectProducts: "Selecciona productos ({{count}} seleccionados):",
    selectMin2: "Selecciona al menos 2 productos",
    noProductsForBundle: "No hay productos. Crea primero productos digitales.",
    originalPrice: "Precio original",
    bundleCreated: "¡Bundle creado!",
    invalidDiscount: "Descuento no válido",
    deleteBundleConfirm: "¿Eliminar este bundle?",
    noBundlesYet: "Ningún bundle creado. ¡Crea paquetes de productos a precio rebajado!",
    bundleProducts: "productos",
  },
  seoCreator: {
    metaTitle: "Link in Bio para Creadores | TuttiIMieiLink",
    metaDesc: "Crea tu link in bio profesional para creadores. Captura leads, vende productos digitales y rastrea conversiones con TuttiIMieiLink.",
    badge: "Para Creadores",
    title: "El link in bio que ",
    titleHighlight: "realmente convierte",
    desc: "No es un simple link-in-bio. TuttiIMieiLink es la herramienta creada para creadores que quieren convertir seguidores en clientes, capturar leads y vender productos digitales.",
    cta: "Empieza gratis",
    viewPlans: "Ver planes",
    whyTitle: "Por qué los creadores eligen TuttiIMieiLink",
    whyDesc: "Los link-in-bio genéricos ya no son suficientes. Necesitas una herramienta que te ayude a monetizar, no solo a recopilar clics.",
    features: [
      { title: "Enlaces ilimitados", desc: "Añade todos los enlaces que quieras: redes sociales, web, portfolio, cursos y más." },
      { title: "Vende productos digitales", desc: "Vende ebooks, presets, plantillas y cursos directamente desde tu página." },
      { title: "Analíticas avanzadas", desc: "Rastrea visitas, clics, CTR, ventas e ingresos en tiempo real." },
      { title: "Temas personalizables", desc: "Elige entre temas premium y personaliza colores, fuentes y estilo." },
      { title: "A/B Test de posición", desc: "Prueba el orden de los enlaces para descubrir qué posición convierte más." },
      { title: "Captura de leads", desc: "Recoge emails y nombres de tus visitantes con formularios integrados." },
    ],
    proofTitle: "Hecho para creadores de contenido",
    proofDesc: "Ya seas influencer, coach, artista o freelancer, TuttiIMieiLink te da las herramientas para convertir tu audiencia en un negocio.",
    stats: [
      { value: "+47%", label: "CTR promedio" },
      { value: "3x", label: "Más ventas" },
      { value: "2min", label: "Configuración inicial" },
    ],
    jsonLdDesc: "Link in bio profesional para creadores. Vende productos digitales, captura leads y rastrea conversiones.",
  },
  seoInstagram: {
    metaTitle: "Link in Bio para Instagram | TuttiIMieiLink",
    metaDesc: "El mejor link in bio para Instagram. Añade múltiples enlaces, vende productos y rastrea los clics desde tu bio de Instagram con TuttiIMieiLink.",
    badge: "Para Instagram",
    title: "El link in bio perfecto para ",
    titleHighlight: "Instagram",
    desc: "Instagram te da un solo enlace en la bio. TuttiIMieiLink te permite añadir todos los que quieras, vender productos y rastrear cada clic.",
    cta: "Crea tu link in bio",
    problemsTitle: "El problema del link in bio de Instagram",
    problems: [
      { title: "Un solo enlace en la bio", desc: "Instagram permite un solo enlace. Con TuttiIMieiLink añades todos los que quieras." },
      { title: "Sin datos de clics", desc: "¿No sabes qué enlaces funcionan? Nuestras analíticas te lo dicen todo." },
      { title: "Cero ventas desde la bio", desc: "Añade productos digitales y vende directamente desde tu página link-in-bio." },
    ],
    howTitle: "Cómo funciona",
    steps: [
      { title: "Crea tu cuenta", desc: "Regístrate gratis en 30 segundos y elige tu nombre de usuario personalizado." },
      { title: "Añade tus enlaces", desc: "Agrega enlaces a tu web, YouTube, tienda, cursos o cualquier otro recurso." },
      { title: "Pégalo en tu bio", desc: "Copia el enlace de tu página y pégalo en la bio de Instagram. ¡Listo!" },
    ],
    featuresTitle: "Todo lo que necesitas",
    features: [
      { title: "Múltiples enlaces", desc: "Añade todos los enlaces que quieras a tu página." },
      { title: "Analíticas en tiempo real", desc: "Visitas, clics, CTR y referrer para cada enlace." },
      { title: "Diseño personalizable", desc: "Temas, colores y fuentes que reflejan tu marca." },
      { title: "Venta de productos", desc: "Vende ebooks, presets y cursos desde tu bio." },
    ],
    jsonLdDesc: "Link in bio para Instagram. Añade múltiples enlaces, vende productos y rastrea conversiones.",
  },
  seoMonetize: {
    metaTitle: "Cómo Monetizar Instagram | TuttiIMieiLink",
    metaDesc: "Descubre cómo monetizar Instagram en 2026. Vende productos digitales, captura leads y convierte seguidores en clientes con TuttiIMieiLink.",
    badge: "Guía de monetización",
    title: "Cómo ",
    titleHighlight: "monetizar Instagram",
    titleEnd: " en 2026",
    desc: "Los seguidores no pagan las facturas. Descubre cómo convertir tu audiencia de Instagram en un negocio real con estrategias concretas y herramientas profesionales.",
    cta: "Empieza a monetizar",
    problemTitle: "El problema: seguidores ≠ dinero",
    problemDesc: "Tener miles de seguidores no es suficiente. Sin una estrategia de monetización clara, estás dejando dinero sobre la mesa. ¿La buena noticia? No necesitas millones de seguidores para ganar. Necesitas las herramientas adecuadas.",
    problemStats: [
      { stat: "82%", label: "de los creadores no monetiza" },
      { stat: "1k", label: "seguidores bastan" },
      { stat: "€500+", label: "al mes posibles" },
      { stat: "2 min", label: "para empezar" },
    ],
    strategiesTitle: "4 estrategias para monetizar Instagram",
    strategiesDesc: "Así es como los creadores exitosos ganan con Instagram usando TuttiIMieiLink.",
    strategies: [
      { title: "Vende productos digitales", desc: "Ebooks, presets de Lightroom, plantillas de Canva, cursos online. Crea una vez, vende para siempre desde tu link in bio." },
      { title: "Recopila emails", desc: "Usa la captura de leads integrada para construir tu lista de correo. Ofrece un freebie a cambio del email y nutre tus contactos." },
      { title: "Optimiza con datos", desc: "Analiza qué enlaces generan más clics, qué posición convierte mejor y de dónde viene tu tráfico." },
      { title: "A/B test automático", desc: "Prueba el orden de los enlaces para maximizar conversiones. El sistema identifica automáticamente al ganador." },
    ],
    readyTitle: "¿Listo para monetizar?",
    readyDesc: "Empieza gratis hoy. Crea tu página, añade tus productos y empieza a ganar con tus seguidores de Instagram.",
    readyCta: "Crea tu cuenta gratis",
    jsonLdHeadline: "Cómo Monetizar Instagram en 2026",
    jsonLdDesc: "Guía completa para monetizar Instagram con productos digitales, captura de leads y analíticas.",
  },
  referralBanner: {
    badge: "Programa de Referidos",
    title: "Invita a un creador, gana el 20% recurrente",
    desc: "Comparte tu enlace de invitación. Por cada creador que se suscriba gracias a ti, ganas automáticamente el 20% de su suscripción. Cada mes. Para siempre.",
    step1Title: "Comparte el enlace",
    step1Desc: "Desde tu panel",
    step2Title: "Ganas el 20%",
    step2Desc: "En cada renovación",
    cta: "Empieza a invitar",
  },
  referral: {
    title: "Programa de Referidos",
    desc: "Invita a otros creadores y gana una comisión recurrente del 20% en cada suscripción que generen.",
    yourLink: "Tu enlace de invitación",
    copied: "¡Enlace copiado!",
    invited: "Invitados",
    subscribed: "Suscritos",
    earned: "Ganado",
    history: "Historial de comisiones",
    howTitle: "¿Cómo funciona?",
    howDesc: "Comparte tu enlace. Cuando alguien se registra y se suscribe, automáticamente ganas el 20% de su suscripción cada mes.",
  },
  seoProducts: {
    metaTitle: "Vender Productos Digitales en Instagram | TuttiIMieiLink",
    metaDesc: "Vende productos digitales en Instagram: ebooks, presets, plantillas y cursos. Checkout integrado, cero comisiones de plataforma. Empieza gratis con TuttiIMieiLink.",
    badge: "Productos digitales",
    title: "Vende ",
    titleHighlight: "productos digitales",
    titleEnd: " en Instagram",
    desc: "Transforma tus habilidades en productos digitales y véndelos directamente desde tu bio de Instagram. Sin web, sin complejidad. Solo ventas.",
    cta: "Empieza a vender",
    typesTitle: "Qué puedes vender",
    typesDesc: "Cualquier archivo digital puede convertirse en un producto. Estas son las categorías más solicitadas por los creadores.",
    types: [
      { title: "Ebooks y guías", desc: "Guías PDF, recetarios, manuales técnicos. Crea una vez, vende para siempre." },
      { title: "Presets y plantillas", desc: "Presets de Lightroom, plantillas de Canva, filtros personalizados para tus seguidores." },
      { title: "Cursos y talleres", desc: "Video cursos, webinars grabados, material didáctico en formato digital." },
      { title: "Recursos premium", desc: "Checklists, planners, hojas de cálculo y cualquier recurso útil para tu nicho." },
    ],
    howTitle: "Cómo funciona la venta",
    howSteps: [
      { title: "Sube tu producto", desc: "Añade título, descripción, precio y sube el archivo desde el panel." },
      { title: "El cliente paga desde tu página", desc: "El visitante hace clic en 'Comprar', introduce su email y paga de forma segura con Stripe." },
      { title: "Descarga automática", desc: "Después del pago, el cliente recibe un enlace de descarga único y seguro." },
    ],
    benefitsTitle: "Por qué vender con TuttiIMieiLink",
    benefits: [
      "Checkout seguro con Stripe integrado",
      "Descarga automática después del pago",
      "Cero comisiones de plataforma",
      "Gestiona todo desde el panel",
      "Analíticas de ventas en tiempo real",
      "Portada de producto personalizable",
    ],
    jsonLdHeadline: "Cómo Vender Productos Digitales en Instagram",
    jsonLdDesc: "Guía completa para vender ebooks, presets, plantillas y cursos en Instagram con TuttiIMieiLink.",
  },
  ai: {
    generating: "Generando...",
    generateBio: "Generar con IA",
    suggestTitle: "Sugerir título",
    generateDesc: "Generar descripción IA",
    error: "Error IA",
    generateError: "No se pudo generar el contenido. Inténtalo de nuevo.",
  },
  routing: {
    smartRouting: "Smart Routing",
    country: "País",
    device: "Dispositivo",
    language: "Idioma",
    selectValue: "Seleccionar...",
    altUrlPlaceholder: "URL alternativa",
    addRule: "Agregar regla",
    ruleAdded: "Regla agregada",
    ruleDeleted: "Regla eliminada",
    rulesLabel: "Reglas de routing",
  },
  testimonials: {
    title: "Testimonios",
    add: "Agregar",
    addBtn: "Agregar",
    cancel: "Cancelar",
    namePlaceholder: "Nombre del cliente",
    rolePlaceholder: "Rol / empresa (opcional)",
    quotePlaceholder: "Escribe la reseña del cliente...",
    rating: "Valoración",
    added: "Testimonio agregado",
    deleted: "Testimonio eliminado",
    photoUploaded: "Foto subida",
    error: "Error al guardar",
    empty: "No hay testimonios todavía. ¡Agrega uno para mostrarlo en tu página!",
    hint: "Los testimonios activos se mostrarán en tu página pública.",
  },
  seoFree: {
    metaTitle: "Link in Bio Gratis | Crea Tu Página en 2 Minutos | TuttiIMieiLink",
    metaDesc: "Crea tu link in bio gratis con TuttiIMieiLink. Página personalizable, analíticas, venta de productos digitales y ganancias por clic. Mejor que Linktree.",
    badge: "100% Gratis · Sin tarjeta de crédito",
    title: "El mejor link in bio ",
    titleHighlight: "gratis para creadores",
    desc: "Crea tu página link-in-bio en 2 minutos. Personalízala, agrega tus enlaces, vende productos digitales y gana por cada clic. Todo gratis, para siempre.",
    cta: "Crea tu link gratis",
    viewPlans: "Ver planes",
    subCta: "Sin tarjeta de crédito · Configuración en 2 minutos",
    featuresTitle: "Todo lo que necesitas, gratis",
    featuresDesc: "Mientras otros cobran por funciones básicas, nosotros te las damos gratis. De verdad.",
    features: [
      { title: "Enlaces ilimitados", desc: "Agrega todos los enlaces que quieras a tu página. Sin límites artificiales." },
      { title: "Temas personalizables", desc: "Elige entre varios temas y fuentes para hacer tu página única." },
      { title: "Analíticas integradas", desc: "Monitorea vistas, clics y conversiones con el panel dedicado." },
      { title: "Venta de productos digitales", desc: "Vende ebooks, cursos y plantillas directamente desde tu página." },
      { title: "Código QR personal", desc: "Genera y descarga el código QR de tu página para compartirlo en cualquier lugar." },
      { title: "Ganancias por clic", desc: "La única plataforma que te paga por cada clic recibido en tu página." },
    ],
    howTitle: "Crea tu link in bio en 3 pasos",
    steps: [
      { title: "Regístrate gratis", desc: "Crea tu cuenta en segundos con email o Google. Sin tarjeta requerida." },
      { title: "Personaliza tu página", desc: "Elige un tema, agrega los enlaces a tus redes sociales, sitio web y contenidos." },
      { title: "Comparte y gana", desc: "Copia tu enlace y agrégalo a la bio de Instagram, TikTok o YouTube. Empieza a ganar." },
    ],
    compTitle: "TuttiIMieiLink vs otros link in bio gratis",
    compDesc: "No todos los link in bio gratuitos son iguales. Esto es lo que nos diferencia.",
    compOthers: "Otras herramientas",
    comparisons: [
      { them: "Máx 5 enlaces", us: "Enlaces ilimitados" },
      { them: "Sin ganancias", us: "Ganancias por clic" },
      { them: "Analíticas limitadas", us: "Analíticas completas" },
      { them: "Sin venta de productos", us: "Venta integrada" },
      { them: "Branding de plataforma", us: "Tu marca" },
    ],
    proofTitle: "Los números hablan por sí solos",
    stats: [
      { value: "1.000+", label: "Creadores activos" },
      { value: "€0", label: "Para empezar" },
      { value: "2 min", label: "Configuración completa" },
    ],
    jsonLdDesc: "Crea tu link in bio gratis con TuttiIMieiLink. Página personalizable, analíticas, venta de productos digitales y ganancias por clic.",
  },
  seoInternalLinks: {
    title: "Guías y recursos para creadores",
    body: "Crea un <free>link in bio gratis</free> como alternativa real a Linktree, optimiza tu <ig>link in bio para Instagram</ig> y descubre cómo un <creator>link in bio para creadores</creator> convierte de verdad. ¿Quieres ganar dinero? Lee las guías sobre cómo <monetize>monetizar Instagram</monetize> y <sell>vender productos digitales online</sell>.",
  },
  exitPopup: {
    title: "¡Espera! No te vayas 👋",
    desc: "Estás a punto de perder la oportunidad de convertir tus seguidores en clientes. Prueba gratis por 7 días, sin riesgo.",
    trialBadge: "7 días de prueba gratis",
    benefits: [
      "Landing pages que convierten, no solo una lista de enlaces",
      "Vende productos digitales sin comisiones",
      "Gana por cada clic que recibes",
      "Analíticas y conversiones en tiempo real",
    ],
    cta: "Prueba gratis 7 días",
    dismiss: "No gracias, prefiero los enlaces normales",
  },
  freeExitPopup: {
    title: "¡Estás dejando dinero sobre la mesa! 💸",
    desc: "Pasa a PRO ahora y desbloquea el doble de ganancias + todas las herramientas avanzadas.",
    countdown: "Oferta válida por {{minutes}}:{{seconds}}",
    discountBadge: "50% de descuento — Solo para ti",
    benefits: [
      "Gana €0.01/clic en vez de €0.005",
      "Analíticas avanzadas y conversiones",
      "Productos digitales y membresías",
      "AI Content Generator y Smart Bio",
      "Reservas y calendario integrado",
    ],
    cta: "Pasa a PRO con 50% de descuento",
    dismiss: "Me quedo con el plan gratuito",
  },
  schedule: {
    title: "Programación",
    startLabel: "Publicar desde",
    endLabel: "Ocultar después de",
    from: "Desde",
    until: "Hasta",
    clear: "Eliminar programación",
    saved: "Programación guardada",
    showCountdown: "Mostrar cuenta atrás en la página",
    countdownDays: "d",
    countdownHours: "h",
    countdownMinutes: "m",
    countdownSeconds: "s",
    countdownExpired: "Oferta expirada",
    countdownEndsIn: "Termina en",
  },
  blog: {
    metaTitle: "Blog | Guías para Creadores - TuttiIMieiLink",
    metaDesc: "Guías, estrategias y consejos para creadores que quieren monetizar las redes sociales.",
    badge: "Blog & Guías",
    title: "Recursos para Creadores",
    subtitle: "Guías prácticas, estrategias de monetización y consejos para convertir tus seguidores en clientes.",
    readMore: "Leer artículo",
    backToList: "Volver al blog",
    related: "Artículos relacionados",
    faqTitle: "Preguntas frecuentes",
    ctaInline: {
      title: "¿Listo para monetizar tus redes?",
      desc: "Crea tu link-in-bio profesional, vende productos digitales y gana por cada clic. Setup en 2 minutos.",
      cta: "Empieza gratis",
    },
    ctaSidebar: {
      title: "Crea tu link-in-bio",
      desc: "El único que te paga por cada clic",
      benefits: [
        "Página personalizable",
        "Venta de productos digitales",
        "Analíticas avanzadas",
        "Ganancias por clic",
        "Pruebas A/B automáticas",
      ],
      earning: "€0.01 / clic",
      cta: "Prueba gratis 7 días",
      sub: "7 días gratis · Cancela cuando quieras",
    },
  },
  creatorScore: {
    description: "Puntuación de credibilidad calculada automáticamente según la actividad del creador.",
    levels: {
      legend: "Leyenda",
      expert: "Experto",
      pro: "Pro",
      rising: "En ascenso",
      new: "Nuevo",
    },
    categories: {
      sales: "Ventas",
      reviews: "Reseñas",
      activity: "Actividad",
      seniority: "Antigüedad",
    },
  },
  storefront: {
    cart: "Carrito",
    cartEmpty: "Tu carrito está vacío",
    suggestions: "También te puede interesar",
    total: "Total",
    emailPlaceholder: "Tu email para la descarga",
    checkout: "Proceder al checkout",
    checkoutLoading: "Cargando...",
    enterEmail: "Introduce tu email",
    error: "Error",
    checkoutError: "No se pudo iniciar el checkout.",
    addToCart: "Añadir al carrito",
    addBundleToCart: "Añadir bundle al carrito",
    bundleOffers: "Ofertas Bundle",
    includes: "Incluye",
    reviews: "Reseñas",
    pageNotFound: "Página no encontrada",
    usernameNotExists: "Este nombre de usuario aún no existe.",
    pageUnavailable: "Página no disponible",
    pageUnavailableDesc: "Esta página aún no es pública. El propietario debe activar un plan para hacerla visible.",
    backHome: "Volver al inicio",
    thankYou: "¡Gracias por suscribirte!",
    downloadSoon: "Tu descarga se abrirá en breve...",
    namePlaceholder: "Tu nombre (opcional)",
    emailFieldPlaceholder: "Tu email",
    submitting: "Enviando...",
    downloadFree: "Descargar gratis",
    subscribe: "Suscribirse",
    createdWith: "Creado con",
    collabPartners: "En colaboración con",
    marketingConsent: "Acepto recibir comunicaciones promocionales por email. Puedo darme de baja en cualquier momento.",
  },
  autoFunnel: {
    title: "AI Auto-Funnel",
    description: "La IA analiza tus enlaces, productos y analytics para sugerirte el orden óptimo, mejor copy y una estrategia de conversión personalizada.",
    analyze: "Analizar mi funnel",
    analyzing: "Analizando...",
    strategy: "Estrategia recomendada",
    linkSuggestions: "Sugerencias de enlaces",
    productTips: "Consejos de productos",
    bioSuggestion: "Bio sugerida",
    apply: "Aplicar",
    applyAll: "Aplicar todo",
    reanalyze: "Re-analizar",
    applied: "¡Sugerencia aplicada!",
    allApplied: "¡Todos los cambios han sido aplicados!",
    error: "Error",
    analyzeError: "No se pudo analizar el funnel.",
  },
  heatmap: {
    title: "Mapa de calor de clics",
    aiTips: "Consejos IA",
    hot: "Caliente",
    warm: "Tibio",
    medium: "Medio",
    cool: "Fresco",
    cold: "Frío",
    suggestions: "Sugerencias para mejorar",
    error: "Error",
  },
  socialProof: {
    title: "Social Proof en Vivo",
    description: "Muestra notificaciones de compras recientes en tu página pública para aumentar las conversiones.",
    saved: "¡Configuración guardada!",
    error: "Error al guardar",
    exampleBought: "acaba de comprar",
    ago: "atrás",
    bought: "acaba de comprar",
    justNow: "ahora",
    minAgo: "min atrás",
    daysAgo: "d atrás",
  },
  collab: {
    title: "Colaboraciones",
    description: "Promociona otros creadores en tu página y ellos te promocionarán a ti. Configura el split de ingresos personalizado.",
    invite: "Invitar",
    usernamePlaceholder: "Username del creador a invitar",
    messagePlaceholder: "Mensaje (opcional)",
    splitLabel: "Split de ingresos",
    you: "Tú",
    partner: "Socio",
    sendInvite: "Enviar invitación",
    cancel: "Cancelar",
    loading: "Cargando...",
    pendingIncoming: "Invitaciones recibidas",
    pendingOutgoing: "Invitaciones enviadas",
    activeCollabs: "Colaboraciones activas",
    noCollabs: "Sin colaboraciones activas. ¡Invita a un creador para empezar!",
    aiTitle: "Encuentra socios con IA",
    aiDescription: "La IA analiza los perfiles de creadores de la plataforma y te propone los mejores socios para un shoutout mutuo.",
    aiFind: "Buscar socios",
    aiFinding: "Analizando...",
    aiEmpty: "Aun no hay socios compatibles. Vuelve a intentarlo cuando haya mas creadores.",
    aiError: "No se pudieron generar coincidencias. Reintenta.",
    aiRateLimit: "Demasiadas solicitudes, intentalo en un momento.",
    aiNoCredits: "Creditos de IA agotados.",
    matchScore: "Afinidad",
    useShoutout: "Invitar con este mensaje",
    statsTitle: "Clics de shoutout",
    clicksSent: "Enviados a socios",
    clicksReceived: "Recibidos de socios",
    last30: "ultimos 30 dias",
    active: "Activa",
    inviteSent: "¡Invitación enviada!",
    accepted: "¡Colaboración aceptada!",
    rejected: "Invitación rechazada.",
    cancelled: "Colaboración cancelada.",
    accept: "Aceptar",
    reject: "Rechazar",
    error: "Error",
  },
  notifications: {
    title: "Notificaciones",
    markAllRead: "Marcar todas como leídas",
    empty: "Sin notificaciones",
  },
  templates: {
    stepLabel: "Plantilla",
    stepDesc: "Elige una plantilla inicial",
    chooseHint: "Elige una plantilla para empezar más rápido, o empieza desde cero.",
    catAll: "Todos",
    catCreative: "Creativos",
    catBusiness: "Negocios",
    catWellness: "Bienestar",
    catFood: "Comida",
    catEntertainment: "Entretenimiento",
    additionalLinks: "Enlaces incluidos en la plantilla:",
    blank: "Desde cero",
    blankDesc: "Página en blanco, totalmente personalizable",
    musician: "Músico",
    musicianDesc: "Para artistas y músicos",
    beautician: "Esteticista",
    beauticianDesc: "Para centros de belleza y spas",
    coach: "Coach",
    coachDesc: "Para coaches, consultores y formadores",
    wedding: "Wedding Planner",
    weddingDesc: "Para organizadores de bodas",
    restaurant: "Restaurante",
    restaurantDesc: "Para restaurantes y locales",
    tattoo: "Tatuador",
    tattooDesc: "Para tatuadores y estudios",
    photographer: "Fotógrafo",
    photographerDesc: "Para fotógrafos y estudios fotográficos",
    personalTrainer: "Personal Trainer",
    personalTrainerDesc: "Para entrenadores personales y fitness coaches",
    artist: "Artista",
    artistDesc: "Para artistas, ilustradores y pintores",
    nutritionist: "Nutricionista",
    nutritionistDesc: "Para nutricionistas y dietistas",
    influencer: "Influencer",
    influencerDesc: "Para creadores de contenido e influencers",
    lawyer: "Abogado",
    lawyerDesc: "Para abogados y bufetes",
    financialAdvisor: "Asesor Financiero",
    financialAdvisorDesc: "Para asesores financieros y gestores patrimoniales",
    psychologist: "Psicólogo",
    psychologistDesc: "Para psicólogos y terapeutas",
    architect: "Arquitecto",
    architectDesc: "Para arquitectos y diseñadores de interiores",
    dj: "DJ",
    djDesc: "Para DJs y productores musicales",
    podcaster: "Podcaster",
    podcasterDesc: "Para podcasters y creadores de audio",
    foodBlogger: "Food Blogger",
    foodBloggerDesc: "Para food bloggers y creadores de recetas",
    pastryChef: "Pastelería",
    pastryChefDesc: "Para pastelerías, cake designers y bakeries",
    mealPlanCreator: "Meal Plan Creator",
    mealPlanCreatorDesc: "Para quienes venden planes de comidas y recetarios digitales",
    selectPreview: "Selecciona una plantilla para ver la vista previa",
    customize: "Personalizar",
    theme: "Tema",
    font: "Fuente",
    accentColor: "Color de acento",
    customColor: "Personalizado",
  },
  smartBio: {
    description: "Personaliza la bio y el orden de los enlaces según la fuente de tráfico de tus visitantes. Quienes lleguen desde Instagram verán una bio diferente a quienes lleguen desde Google.",
    noRules: "Sin reglas Smart Bio. Añade una fuente de tráfico para empezar.",
    customBio: "Bio personalizada",
    bioPlaceholder: "Deja vacío para usar la bio predeterminada...",
    linkOrder: "Orden de enlaces personalizado",
    addSource: "Añadir fuente de tráfico",
    active: "Activa",
    inactive: "Inactiva",
    save: "Guardar reglas Smart Bio",
    saving: "Guardando...",
    saved: "¡Reglas Smart Bio guardadas!",
    error: "Error al guardar las reglas",
  },
  smartBioLanding: {
    badge: "Smart Bio",
    title: "Una bio diferente para cada visitante",
    desc: "Quien llega desde Instagram ve contenido diferente a quien llega desde Google. Bio personalizada y orden de enlaces automático según la fuente de tráfico.",
    from: "de",
    sources: {
      instagram: "Instagram",
      tiktok: "TikTok",
      google: "Google",
      direct: "Enlace directo",
    },
    features: [
      "Bio personalizada para cada fuente de tráfico",
      "Orden de enlaces optimizado automáticamente",
      "Compatible con Instagram, TikTok, Google, Facebook y más",
      "Sin configuración técnica necesaria",
    ],
    demos: [
      { bio: "🔥 ¡Descubre el contenido exclusivo que solo comparto en Instagram!", links: ["Último Reel ▶️", "Tienda Instagram", "Filtros & Presets", "Newsletter"] },
      { bio: "🎵 Mis tendencias virales y tutoriales exclusivos", links: ["Videos Virales 🔥", "Tutoriales", "Tienda TikTok", "Sígueme"] },
      { bio: "👋 ¡Bienvenido! Descubre mis servicios y productos digitales", links: ["Servicios", "Productos Digitales", "Sobre Mí", "Contacto"] },
      { bio: "¡Hola! Aquí están todos mis enlaces importantes 🚀", links: ["Portafolio", "Blog", "Tienda Online", "Contacto"] },
    ],
    autoLabel: "100% automático ✨",
  },
  booking: {
    services: "Servicios reservables",
    addService: "Añadir servicio",
    serviceTitle: "Nombre del servicio (ej. Consulta 1-a-1)",
    serviceDesc: "Descripción (opcional)",
    duration: "Duración (min)",
    price: "Precio (€)",
    save: "Guardar",
    free: "Gratis",
    noServices: "Ningún servicio creado aún.",
    serviceCreated: "¡Servicio creado!",
    addSlots: "Añadir disponibilidad",
    selectService: "Servicio",
    chooseService: "Elige un servicio...",
    date: "Fecha",
    from: "Desde",
    to: "Hasta",
    generateSlots: "Generar slots",
    noSlots: "No se pueden generar slots en este rango.",
    slotsCreated: "¡{{count}} slots creados!",
    upcomingSlots: "Próximos slots",
    booked: "Reservado",
    recentBookings: "Reservas recientes",
    name: "Nombre",
    service: "Servicio",
    dateTime: "Fecha/Hora",
    payment: "Pago",
    paid: "Pagado",
    bookSession: "Reserva una sesión",
    chooseServicePublic: "Elige un servicio",
    selectSlot: "Elige un horario",
    noAvailableSlots: "No hay slots disponibles por el momento.",
    back: "Volver",
    yourName: "Tu nombre",
    yourEmail: "Tu email",
    notesOptional: "Notas (opcional)",
    bookNow: "Reservar ahora",
    confirmed: "¡Reserva confirmada!",
    confirmationSent: "Recibirás un email de confirmación.",
    bookingError: "Error en la reserva",
    tryAgain: "Inténtalo de nuevo.",
    payAndBook: "Pagar y reservar",
    confirmingPayment: "Confirmando pago...",
    paymentConfirmed: "¡Pago confirmado y reserva completada!",
    status: "Estado",
    actions: "Acciones",
    cancelled: "Cancelada",
    rescheduled: "Reprogramada",
    cancelBooking: "Cancelar reserva",
    rescheduleBooking: "Reprogramar reserva",
    cancelBookingTitle: "¿Cancelar esta reserva?",
    cancelBookingDesc: "El visitante será notificado por email. El slot volverá a estar disponible.",
    confirmCancel: "Sí, cancelar",
    rescheduleBookingTitle: "Reprogramar reserva",
    rescheduleBookingDesc: "Elige un nuevo horario para la reserva de {{name}}. El visitante será notificado.",
    confirmReschedule: "Confirmar reprogramación",
    bookingCancelled: "Reserva cancelada con éxito",
    bookingRescheduled: "Reserva reprogramada con éxito",
    recurringAvailability: "Disponibilidad recurrente",
    recurringDesc: "Configura reglas de disponibilidad automática. Los slots se generan cada noche para los próximos días.",
    addRule: "Añadir regla",
    dayOfWeek: "Día de la semana",
    sunday: "Domingo",
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miércoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sábado",
    advanceDays: "Días de antelación",
    advanceDaysLabel: "{{days}} días de antelación",
    ruleCreated: "¡Regla de disponibilidad creada!",
    generateNow: "Generar ahora",
    slotsGeneratedFromRules: "¡{{count}} slots generados desde las reglas!",
  },
  blogPreview: {
    title: "Recursos para creadores que quieren vender más",
    desc: "Guías, estrategias y consejos prácticos para monetizar tus redes sociales.",
    viewAll: "Leer todos los artículos",
  },
  seoInternal: {
    title: "Otras guías útiles",
    desc: "Descubre nuestras guías completas para creadores y marcas",
    descCreator: "Crea tu link-in-bio profesional",
    descInstagram: "Optimiza el link en tu bio de Instagram",
    descMonetize: "Estrategias para ganar con Instagram",
    descProducts: "Vende ebooks, cursos y plantillas",
    descFree: "Empieza gratis con tu link-in-bio",
    descBooking: "Recibe reservas online desde tu link in bio",
  },
  seoBooking: {
    metaTitle: "Reservas Online desde tu Link in Bio | TuttiIMieiLink",
    metaDesc: "Recibe reservas online desde tu link in bio: calendario, pago por adelantado y recordatorios automáticos. Con Deeplink™ el cliente reserva sin salir de la red social.",
    badge: "Reservas online · Incluidas en tu link in bio",
    title: "Reservas online ",
    titleHighlight: "directamente desde tu link in bio",
    desc: "Tu link in bio se convierte en una agenda: los clientes eligen día y hora, pagan al momento y reciben confirmación y recordatorio por email. Sin software de reservas adicional.",
    cta: "Activa las reservas gratis",
    viewPlans: "Ver planes",
    subCta: "Sin tarjeta · Listo en 2 minutos",
    whyTitle: "Todo lo que necesitas para gestionar reservas online",
    whyDesc: "Consultorías, clases, sesiones, citas en tienda: define tu disponibilidad y deja que los clientes reserven solos.",
    features: [
      { title: "Calendario con disponibilidad real", desc: "Defines días, horarios y duración: la página solo muestra los huecos realmente libres." },
      { title: "Pago al reservar", desc: "Cobra con tarjeta, Apple Pay o Google Pay antes de la cita y reduce las ausencias." },
      { title: "Confirmaciones y recordatorios automáticos", desc: "Email de confirmación inmediato y recordatorio antes de la cita, sin escribir nada." },
      { title: "Cambios y cancelaciones", desc: "El cliente puede mover la hora y tú recibes la notificación actualizada al instante." },
      { title: "Estadísticas de reservas", desc: "Mira cuántas personas visitan la página, cuántas reservan y cuánto facturas." },
      { title: "Deeplink™ para no perder clientes", desc: "El enlace se abre en el navegador real y no en el interno de la app: pagos y accesos funcionan a la primera." },
    ],
    howTitle: "Activa las reservas en 3 pasos",
    steps: [
      { title: "Crea tu link in bio", desc: "Regístrate gratis y elige tu dirección: tuttimieilink.com/tunombre." },
      { title: "Añade tu servicio reservable", desc: "Indica nombre, duración, precio y las franjas horarias disponibles." },
      { title: "Comparte el enlace en redes", desc: "Ponlo en tu bio de Instagram, TikTok o YouTube y empieza a recibir reservas." },
    ],
    deeplinkTitle: "Por qué el Deeplink™ marca la diferencia en las reservas",
    deeplinkDesc: "Cuando alguien toca un enlace dentro de Instagram o TikTok, la página se abre en el navegador interno de la app: sesiones perdidas, accesos que fallan y pagos que se bloquean. El Deeplink™ de TuttiIMieiLink lleva al visitante al navegador real del móvil, así el calendario carga bien y la reserva se completa.",
    faqTitle: "Preguntas frecuentes sobre reservas online",
    faqs: [
      { q: "¿Puedo recibir reservas online gratis?", a: "Sí. Creas tu link in bio gratis y activas un servicio reservable sin tarjeta. Los planes de pago añaden estadísticas avanzadas y servicios ilimitados." },
      { q: "¿Los clientes pagan al reservar?", a: "Tú decides: cobro por adelantado con tarjeta, Apple Pay o Google Pay, o reserva sin pago y cobro presencial." },
      { q: "¿Cómo evito reservas duplicadas?", a: "Los huecos reservados desaparecen al momento del calendario público, así dos personas no pueden coger la misma hora." },
      { q: "¿El cliente recibe recordatorio?", a: "Sí: confirmación por email tras reservar y recordatorio automático antes de la cita." },
      { q: "¿Qué es el Deeplink™?", a: "Es la tecnología que abre tus enlaces en el navegador real del móvil en vez del navegador interno de las redes, para que pagos, accesos y reservas no se rompan." },
      { q: "¿Necesito otro software de reservas?", a: "No. Calendario, pagos, emails y página pública ya están en TuttiIMieiLink, todo desde el panel de tu link in bio." },
    ],
  },
  panels: {
    stripeAccount: "Tu cuenta de Stripe",
    enterBothKeys: "Introduce ambas claves",
    error: "Error",
    uploadError: "Error de subida",
    tipButtonMessage: "Mensaje del botón",
    tipDefaultLabel: "Invítame un café ☕",
    tipSaveError: "El Tip Jar no se ha guardado. Inténtalo de nuevo.",
    saveSettings: "Guardar ajustes",
    newAmount: "Nuevo importe (€)",
    editTier: "Editar tier",
    newTier: "Nuevo tier",
    tierNamePlaceholder: "Nombre del tier (ej. Bronze, Gold, Diamond)",
    tierDescPlaceholder: "Descripción (qué incluye este tier)",
    pricePerMonth: "Precio (€/mes)",
    cancel: "Cancelar",
    editContent: "Editar contenido",
    newContent: "Nuevo contenido",
    contentTitlePlaceholder: "Título del contenido",
    contentBodyPlaceholder: "Contenido (texto, enlaces, instrucciones...)",
    loading: "Cargando...",
    deleteContentConfirm: "¿Eliminar este contenido?",
    searchContacts: "Buscar email o nombre...",
    all: "Todos",
    emailCol: "Email",
    nameCol: "Nombre",
    firstVisitCol: "Primera visita",
  },
};

export default es;
